import { useSelector } from "react-redux";

import messages from "../../../../../../assets/locale/messages";
import Alert from "../../../../../../components/Alert";
import { ChipInfoIcon } from "../../../../../../utils/Icons";
import { BANNER_COLORS } from "../../../../../../utils/Constants";
import { checkForMultiline } from "../../../../../../utils/Helpers";

const RequiredDocsEdit = () => {
  const lang = useSelector((state) => state.locale.lang);
  const {
    businessVerification: {
      requestDetails: {
        offplatformRequest: { requiredDocsEdit }
      }
    }
  } = messages[lang];

  const requestDetails = useSelector(
    (state) =>
      state.businessVerification.offPlatformVerificationRequestDetails
  );

  const renderAlertContent = () => (
    <div className="needed-edits">
      <p className="fsize-16 text-error fweight-600 mb-1">
        {requiredDocsEdit}
      </p>
      <p className="text-light-grey mb-0">
        {checkForMultiline(requestDetails?.EditNotes)}
      </p>
    </div>
  );

  return (
    requestDetails?.EditNotes && (
      <div className="required-docs-edit mb-3">
        <Alert
          type="error"
          content={renderAlertContent()}
          icon={<ChipInfoIcon color={BANNER_COLORS.error} />}
        />
      </div>
    )
  );
};

export default RequiredDocsEdit;
